module.exports = __webpack_public_path__ + "static/media/editor-icon-unordered-list.d483cce9.svg";